import axios, { AxiosError } from "axios";

/**
 * Attempts to extract the error message from an exception.
 */
export function getExceptionToastDescription(exception: unknown) {
  if (isApiError(exception)) {
    return exception.response.data.detail;
  }

  if (exception instanceof Error) {
    return exception.message;
  }

  if (hasMessage(exception)) {
    return String(exception.message);
  }

  return String(exception);
}

type ApiError = {
  response: {
    status: number;
    data: { detail: string };
  };
};

function isApiError(object: unknown): object is ApiError {
  if (typeof object !== "object" || object === null) {
    return false;
  }

  const { response } = object as ApiError;

  if (typeof response !== "object") {
    return false;
  }

  const { status, data } = response;

  return typeof status === "number" && typeof data === "object";
}

function hasMessage(input: unknown): input is { message: string } {
  return (
    typeof input === "object" &&
    input !== null &&
    Object.prototype.hasOwnProperty.call(input, "ticket_type")
  );
}

/**
 * Utility to check if an error is an Axios error.
 *
 * @param error - The error to check.
 * @returns True if the error is an Axios error, otherwise false.
 */
export const isAxiosError = (error: unknown): error is AxiosError => {
  return axios.isAxiosError(error);
};

/**
 * Tries to extract an error message from an Error object.
 * If it can't, it produces "Unknown error"
 */
export const extractErrorMessage = (error: unknown): string => {
  return error instanceof Error ? error.message : "Unknown error";
};
